import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class LocationService extends GenericService {
  constructor() {
    super('/locations', axiosInstance);
  }
}

export default new LocationService(); 